import { h, Component } from 'preact';
import { BaseField } from '../BaseField';
import { IBaseFieldProps, IBaseFieldState } from '../IBaseField';
import { IDynamicFieldState, IDynamicFieldProps } from './IDynamicField';
import { FormFieldTypes } from '../../../../enums/FormFieldTypes';
import { TextBox } from '../textBox/TextBox';
import { ITextBoxProps } from '../textBox/ITextBox';
import { IRadioButtonListProps } from '../radioButtonList/IRadioButtonList';
import { RadioButtonList } from '../radioButtonList/RadioButtonList';
import { IDropDownProps } from '../dropDown/IDropDown';
import { DropDown } from '../dropDown/DropDown';

import { bind, memoize, debounce } from 'decko';

//let style = require('./style.css');

export class DynamicField extends BaseField<IDynamicFieldProps, IDynamicFieldState> {

    public value: string;

    @bind
    public onChange(value) {
        this.value = value;
        if (this.props.onChange)
            this.props.onChange(value);
    }

    render() {

        switch (this.props.fieldType) {
            case FormFieldTypes.Textbox:
                var props = this.props as ITextBoxProps;
                return <div><TextBox {...props} onChange={this.onChange}></TextBox></div>
            case FormFieldTypes.RadioButtonList:
                var rprops = this.props as IRadioButtonListProps;
                return <div><RadioButtonList {...rprops} onChange={this.onChange}></RadioButtonList></div>
            case FormFieldTypes.Dropdown:
                var dprops = this.props as IDropDownProps;
                return <div><DropDown {...dprops} onChange={this.onChange}></DropDown></div>
            default:
                return <div></div>
        }

    }
}



// WEBPACK FOOTER //
// ./components/forms/fields/dynamicField/DynamicField.tsx